import {
  AffiliationList,
  type AffiliationEntry,
} from "@platform/features/affiliations";
import type { OptionType } from "@themes/pollinator/ui/Select";
import { SubStepLayout } from "@platform/features/onboarding/components/SubStepLayout";

export type { AffiliationEntry };

export type Props = {
  /** Current affiliations value */
  affiliations: AffiliationEntry[];
  /** Handler when affiliations change */
  onAffiliationsChange: (value: AffiliationEntry[]) => void;
  /** Organization options for select */
  organizationOptions: OptionType[];
  /** Role options for select */
  roleOptions: OptionType[];
  /** Whether options are loading */
  isOptionsLoading?: boolean;
  /** Handler for creating new organization */
  onCreateOrganization?: (name: string) => void;
  /** Maximum number of affiliation entries */
  maxItems?: number;
  /** Handler for continue/next button */
  onContinue: () => void;
  /** Handler for back button (hidden if undefined) */
  onBack?: () => void;
  /** Handler for skip button (hidden if undefined) */
  onSkip?: () => void;
  /** Current step index (0-indexed) */
  stepIndex: number;
  /** Total steps */
  totalSteps: number;
};

/**
 * Presentational affiliations sub-step for profile onboarding.
 * Allows users to add organization and role affiliations.
 */
export function AffiliationsSubStep({
  affiliations,
  onAffiliationsChange,
  organizationOptions,
  roleOptions,
  isOptionsLoading = false,
  onCreateOrganization,
  maxItems = 3,
  onContinue,
  onBack,
  onSkip,
  stepIndex,
  totalSteps,
}: Props) {
  return (
    <SubStepLayout
      title="Organization Affiliations"
      description="Add organizations you're affiliated with and your role there."
      stepIndex={stepIndex}
      totalSteps={totalSteps}
      onPrimaryClick={onContinue}
      onBack={onBack}
      onSkip={onSkip}
      primaryButtonText="Save & Continue"
    >
      <div className="flex flex-col gap-4">
        <AffiliationList
          name="affiliations"
          value={affiliations}
          onChange={onAffiliationsChange}
          organizationOptions={organizationOptions}
          roleOptions={roleOptions}
          isLoading={isOptionsLoading}
          onCreateOrganization={onCreateOrganization}
          maxItems={maxItems}
        />
      </div>
    </SubStepLayout>
  );
}

export default AffiliationsSubStep;
